if (typeof InfoTabs !== 'function') {

  class InfoTabs extends HTMLElement {

    connectedCallback() {
      this.tabs    = this.querySelectorAll('.js-info-tab');
      this.panels  = this.querySelectorAll('.js-info-panel');
      this.index   = 0;
      this.timeout = null;
      this._timeoutInterval = parseInt(this.dataset.tabsAutoplayTimer * 1000) || 5000;
      this.zIndex  = 99;

      // Ensure the initially-active panel is visible
      const firstPanel = this.querySelector('.js-info-panel.active');
      if (firstPanel) {
        firstPanel.style.zIndex = this.zIndex;
        firstPanel.style.opacity = 1;
      }

      // Show the first tab's caption immediately (no animation on initial load)
      const firstTab = this.querySelector('.js-info-tab.active');
      if (firstTab && window.innerWidth >= 768) {
        const firstCaption = firstTab.querySelector('.info-tabs__tab-caption');
        if (firstCaption) {
          firstCaption.style.display = 'block';
        }
      }

      // Disable autoplay on mobile
      if (window.innerWidth < 768) {
        this.dataset.tabsAutoplay = 'false';
      }

      if (this.dataset.tabsAutoplay === 'true' && this.tabs.length > 1) {
        this.autoplay(this._timeoutInterval, true);

        const togglers = this.querySelector('.info-tabs_togglers');
        if (togglers) {
          togglers.addEventListener('mouseover', () => {
            if (this.timeout > 0) {
              this._timeoutRemaining = this._timeoutInterval - (new Date().getTime() - this._timeoutStart);
              clearTimeout(this.timeout);
              this.timeout = 0;
            }
          });

          togglers.addEventListener('mouseleave', () => {
            this.autoplay(this._timeoutRemaining, true);
            this._timeoutInterval = this._timeoutRemaining;
          });
        }
      }

      this.tabs.forEach(tab => {
        tab.addEventListener('click', e => {
          if (!e.currentTarget.classList.contains('active')) {
            const panelID = e.currentTarget.getAttribute('rel');
            const panel   = document.getElementById(`panel-${panelID}`);

            this.reset();
            this.index = parseInt(e.currentTarget.dataset.index);
            e.currentTarget.classList.add('active');

            // Smooth scroll on mobile
            if (!document.body.classList.contains('no-touchevents') && window.innerWidth < 767) {
              const togglers = this.querySelector('.info-tabs_togglers');
              if (togglers) {
                togglers.scrollTo({ left: e.currentTarget.offsetLeft - 40, behavior: 'smooth' });
              }
            }

            this.slideDown(e.currentTarget.querySelector('.info-tabs__tab-caption'), 200);

            if (panel) {
              panel.classList.add('active');
              panel.style.zIndex = ++this.zIndex;
              panel.style.opacity = 1;
            }
          }
        });
      });
    }

    autoplay(delay, reset = false) {
      if (reset) {
        this._timeoutStart = new Date().getTime();
      }
      this.timeout = setTimeout(() => {
        this.index = (this.index + 1 >= this.tabs.length) ? 0 : this.index + 1;
        if (this.tabs[this.index]) this.tabs[this.index].click();
        this._timeoutInterval = parseInt(this.dataset.tabsAutoplayTimer * 1000) || 5000;
        this.autoplay(this._timeoutInterval, true);
      }, delay);
    }

    reset() {
      clearTimeout(this.timeout);
      this._timeoutInterval = parseInt(this.dataset.tabsAutoplayTimer * 1000) || 5000;
      this._timeoutRemaining = this._timeoutInterval;

      this.querySelectorAll('.active').forEach(el => {
        const caption = el.querySelector('.info-tabs__tab-caption');
        if (caption) this.slideUp(caption, 200);
        el.classList.remove('active');
      });
    }

    slideUp(target, duration) {
      if (window.innerWidth < 768) return;
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.height = target.offsetHeight + 'px';
      target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      setTimeout(() => {
        target.style.display = 'none';
        ['height', 'padding-top', 'padding-bottom', 'margin-top',
          'margin-bottom', 'overflow', 'transition-duration', 'transition-property'
        ].forEach(p => target.style.removeProperty(p));
      }, duration);
    }

    slideDown(target, duration) {
      if (!target || window.innerWidth < 768) return;
      target.style.removeProperty('display');
      let display = window.getComputedStyle(target).display;
      if (display === 'none') display = 'block';
      target.style.display = display;
      const height = target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      target.offsetHeight;
      target.style.boxSizing = 'border-box';
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.height = height + 'px';
      ['padding-top', 'padding-bottom', 'margin-top', 'margin-bottom'].forEach(p => target.style.removeProperty(p));
      setTimeout(() => {
        ['height', 'overflow', 'transition-duration', 'transition-property'].forEach(p => target.style.removeProperty(p));
      }, duration);
    }
  }

  if (typeof customElements.get('info-tabs') === 'undefined') {
    customElements.define('info-tabs', InfoTabs);
  }

}
